export default __webpack_public_path__ + "assets/images/593ab34ea441e28dc9c0088e0da540ad.png";